/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var CHECKED_CODE_REG = /(enter|space)/i;
function useKeyboardEvent(handleChange) {
  var keyboardEventListener = function keyboardEventListener(e) {
    var isCheckedCode = CHECKED_CODE_REG.test(e.key) || CHECKED_CODE_REG.test(e.code);
    if (isCheckedCode) {
      e.preventDefault();
      var _e$currentTarget$quer = e.currentTarget.querySelector("input"),
        disabled = _e$currentTarget$quer.disabled;
      !disabled && handleChange(e);
    }
  };
  var onCheckboxFocus = function onCheckboxFocus(e) {
    e.currentTarget.addEventListener("keydown", keyboardEventListener);
  };
  var onCheckboxBlur = function onCheckboxBlur(e) {
    e.currentTarget.removeEventListener("keydown", keyboardEventListener);
  };
  return {
    onCheckboxFocus: onCheckboxFocus,
    onCheckboxBlur: onCheckboxBlur
  };
}

export { CHECKED_CODE_REG, useKeyboardEvent as default, useKeyboardEvent };
//# sourceMappingURL=useKeyboardEvent.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/checkbox/hooks/useKeyboardEvent.js
// module id = null
// module chunks = 